import React from 'react'
import { TabSkeleton, RestaurantSkeleton, HomeChefSkeleton, CloudKitchenSkeleton } from './Skeletons';
import { isMobile, isDesktop, isIpad } from './../../../global/ScreenSizeHelper'
import PageBase from '../../../composed/pagebase/pagebase';

const StoreListSkeleton = () => {

    if (isDesktop) {
        return (
            <PageBase>
                <div style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }}>
                    <TabSkeleton />
                    <div style={{
                        minWidth: '260px', height: '365px', width: '800px', display: 'flex', border: '1px solid lightgrey',
                        flexDirection: 'column', margin: '15px 5px', padding: '15px', borderRadius: '5px', overflow: 'hidden'
                    }}>
                        <div style={{ fontSize: '16px', fontWeight: '700', color: 'grey', marginLeft: '10px' }}> Restaurants</div>
                        {[1, 2, 3].map((n) => <RestaurantSkeleton key={n} />)}
                    </div>

                </div>
                <div style={{ fontSize: '16px', fontWeight: '700', color: 'grey', margin: '10px' }}> Home Chefs</div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {[1, 2, 3].map((n) => <HomeChefSkeleton key={n} />)}
                </div>
                <CloudKitchenSkeleton />
            </PageBase>
        )
    }
    if (isIpad) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', margin: '10px' }}>
                <TabSkeleton />
                <div style={{
                    minWidth: '260px', height: 'auto', width: 'auto', display: 'flex', border: '1px solid lightgrey',
                    flexDirection: 'column', margin: '15px 5px', padding: '15px', borderRadius: '5px', overflow: 'hidden'
                }}>
                    <div style={{ fontSize: '16px', fontWeight: '700', color: 'grey', marginLeft: '10px' }}> Restaurants</div>
                    {[1, 2, 3].map((n) => <RestaurantSkeleton key={n} />)}
                </div>
                <div style={{ fontSize: '16px', fontWeight: '700', color: 'grey', margin: '10px' }}> Home Chefs</div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {[1, 2, 3].map((n) => <HomeChefSkeleton key={n} />)}
                </div>
                <CloudKitchenSkeleton />
            </div>
        )


    }
    if (isMobile) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <TabSkeleton />
                <div style={{
                    minWidth: '260px', height: 'auto', width: 'auto', display: 'flex', border: '1px solid lightgrey',
                    flexDirection: 'column', margin: '15px', padding: '8px', borderRadius: '5px', overflow: 'hidden'
                }}>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: 'grey', marginLeft: '10px' }}> Restaurants</div>
                    {[1, 2, 3].map((n) => <RestaurantSkeleton key={n} />)}
                </div>
                <div style={{ fontSize: '16px', fontWeight: '700', color: 'grey', margin: '10px', marginLeft: '15px' }}> Home Chefs</div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {[1, 2].map((n) => <HomeChefSkeleton key={n} />)}
                </div>
                <CloudKitchenSkeleton />

            </div>
        )
    }

}

export default StoreListSkeleton